import { render, staticRenderFns } from "./EditSponsorSocials.vue?vue&type=template&id=2f04b422"
import script from "./EditSponsorSocials.vue?vue&type=script&lang=js"
export * from "./EditSponsorSocials.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports